import TableOfContents from './TableOfContents';

const toc = new TableOfContents();
toc.init();
